import appGlobalScript from '/home/runner/work/amwal-checkout/amwal-checkout/stencil-library/node_modules/@ionic/core/dist/collection/global/ionic-global.js';
export const globalScripts = appGlobalScript;
